<template>
  <div>
    <div v-if="isCourseDirector">
      <tabs
        class="d-none d-md-block"
        pills
        type="primary"
        icons
        centered
        value="position"
      >
        <tab-pane
          id="staff"
          key="staff"
        >
          <span slot="title">
            <div class="row align-items-center">
              <div class="content-heading">Staff Recommendations</div>
            </div>
          </span>
          <br>
          <report-closeout-recommendations-staff />
        </tab-pane>
        <tab-pane
          id="participants"
          key="participants"
        >
          <span slot="title">
            <div class="row align-items-center">
              <div class="content-heading">Participant Recommendations</div>
            </div>
          </span>
          <br>
          <report-closeout-recommendations-participant
            @participants-counted="participantsCounted"
          />
        </tab-pane>
        <tab-pane
          id="uncertified"
          key="uncertified"
        >
          <span slot="title">
            <div class="row align-items-center">
              <div class="content-heading">Uncertified Participants</div>
            </div>
          </span>
          <br>
          <report-closeout-uncertified-participants />
        </tab-pane>
        <tab-pane
          id="comments"
          key="comments"
        >
          <span slot="title">
            <div class="row align-items-center">
              <div class="content-heading">Comments</div>
            </div>
          </span>
          <br>
          <report-closeout-other-comments :is-small-course="isSmallCourse" />
        </tab-pane>
      </tabs>
      <button
        class="btn btn-primary"
        @click="$router.push('/staff/reports/closeout/print')"
      >
        Print
      </button>
    </div>
    <div v-else>
      <h4>This page is for course directors only.</h4>
    </div>
  </div>
</template>

<script>
import ReportCloseoutRecommendationsStaff from '@/components/reports/closeout/report-closeout-recommendations-staff-edit.vue'
import ReportCloseoutRecommendationsParticipant from '@/components/reports/closeout/report-closeout-recommendations-participant-edit.vue'
import ReportCloseoutUncertifiedParticipants from '@/components/reports/closeout/report-closeout-uncertified-participants-edit.vue'
import ReportCloseoutOtherComments from '@/components/reports/closeout/report-closeout-other-comments-edit.vue'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'

export default {
  name: 'ReportCloseoutEdit',
  components: {
    Tabs,
    TabPane,
    ReportCloseoutRecommendationsStaff,
    ReportCloseoutRecommendationsParticipant,
    ReportCloseoutUncertifiedParticipants,
    ReportCloseoutOtherComments
  },
  data: function () {
    return {
      isSmallCourse: false
    }
  },
  computed: {
    isCourseDirector: function () {
      return this.$root.isCourseDirector
    }
  },
  methods: {
    participantsCounted: function (count) {
      this.isSmallCourse = count < 30
    }
  }
}
</script>
